/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { WorkspaceModel, WorkspaceRepository } from '@database/central';
import { NavController, Platform } from '@ionic/angular';
import { ArchivedVisibilityTypeEnum, WorkFileAppModel } from './models';
import { filter, map, switchMap } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AlertService, AppRoutingKeys, ToastDuration, ToastService, readFileExtension, removeFileExtension, FileModel, ErrorCodes } from '@shared';
import { Subscription } from 'rxjs';
import { BurgerMenuState } from './services';
import { DeleteWorkfileService } from '../../../domain/business-layer/services/delete-workfile.service';
import { CentralDatabaseKeys } from '../../../database/central-database/schemas/central-database-keys';
import { TranslateService } from '@ngx-translate/core';
import { AuthProvider } from '@domain/authentication';
import { QueryParamsProvider } from '@domain/routing';
import { RequestsStatusState } from '@api/external-transfer';
import { FilePicker, ImportStatusEnum } from '@shared/plugins';
import { LoggingService } from '@shared/logging';
import { LoadingIndicatorState } from '@shared';
import { AccountStateService } from '../../../pages/account/services/account-state.service';
@Component({
	selector: 'app-burger-menu',
	templateUrl: './burger-menu.component.html',
	styleUrls: ['./burger-menu.component.scss']
})
export class BurgerMenuComponent implements OnInit, OnDestroy {
	public workfiles: WorkFileAppModel[];
	public workfileId: string;
	public currentWorkspaceId: string;
	public currentProjectNumber: string;
	public menuCssClass: string;
	public visibilityTypeEnum = ArchivedVisibilityTypeEnum;
	public menuIsEnabled: boolean;
	private subscriptions: Subscription[] = [];
	public importStatus = ImportStatusEnum.noImport;
	public importStatusEnum = ImportStatusEnum;
	public fileName: string;

	public constructor(
		private filePicker: FilePicker,
		private workspaceRepository: WorkspaceRepository,
		private loggingService: LoggingService,
		private navCtrl: NavController,
		private route: ActivatedRoute,
		private router: Router,
		private platform: Platform,
		private burgerMenuState: BurgerMenuState,
		private deleteWorkfileService: DeleteWorkfileService,
		private toastService: ToastService,
		private translateService: TranslateService,
		private alertService: AlertService,
		private authProvider: AuthProvider,
		private queryParamsProvider: QueryParamsProvider,
		private requestsStatusState: RequestsStatusState,
		private loadingIndicatorState: LoadingIndicatorState
	) {}

	public async ngOnInit(): Promise<void> {
		
		this.workfileId = this.queryParamsProvider.workfileId;

		if (this.platform.is('android') || this.platform.is('ios')) {
			this.menuCssClass = 'notch-fix';
		}

		this.subscriptions.push(
			this.router.events
				.pipe(
					filter((e) => e instanceof NavigationEnd),
					map(() => this.route.firstChild)
				)
				.subscribe((route: ActivatedRoute) => {
					if (route.snapshot.firstChild) {
						this.currentWorkspaceId =
							route.snapshot.firstChild.params[AppRoutingKeys.queryParamsMap.workfileId];
						this.currentProjectNumber =
							route.snapshot.firstChild.params[AppRoutingKeys.queryParamsMap.projectNumber];
					}
				})
		);

		this.subscriptions.push(
			this.authProvider.fusionUserId$
				.pipe(
					switchMap((fusionUserId: string | null) =>
						this.burgerMenuState.showArchived$.pipe(
							switchMap((showArchived: boolean) =>
								this.workspaceRepository.getAllByFusionUserId$(fusionUserId).pipe(
									map((workfilesDb: WorkspaceModel[]) =>
										workfilesDb
											.sort((a, b) => a.importedUnix - b.importedUnix)
											.filter((workfile: WorkspaceModel) => {
												if (!showArchived && workfile.archived && !workfile.pendingDelete) {
													return false;
												}

												return true;
											})
											.map((workfile: WorkspaceModel) => ({
												...workfile,
												isExpanded: true
											}))
									)
								)
							)
						)
					)
				)
				.subscribe((workfiles: WorkFileAppModel[]) => {
					this.workfiles = workfiles;
				})
		);
		this.toggleBurgerMenuVisibility();
	}

	public async selectWorkFile(workfile: WorkspaceModel): Promise<void> {
		if (workfile.pendingDelete) {
			return await this.toastService.presentError(
				this.translateService.instant('burgerMenu.deleteValidations.partiallyDeleted'),
				ToastDuration.Fast
			);
		}

		const anyRequestsInProgress: boolean = this.isAnyRequestInProgress(workfile.workFileId);
		if (anyRequestsInProgress) {
			return;
		}

		await this.navCtrl.navigateRoot(`/${AppRoutingKeys.urlPathWorkfile}/${workfile.workFileId}`);
	}

	public async selectProject(workfileId: string, projectNumber: string): Promise<void> {
		const anyRequestsInProgress: boolean = this.isAnyRequestInProgress(workfileId);
		if (anyRequestsInProgress) {
			return;
		}

		await this.navCtrl.navigateForward(
			`/${AppRoutingKeys.urlPathWorkfile}/${workfileId}/${AppRoutingKeys.urlPathProject}/${projectNumber}`
		);
	}

	public async importWorkfile(): Promise<void> {
		await this.navCtrl.navigateForward(AppRoutingKeys.urlPathImport);
	}

	public async appendWorkfile(): Promise<void> {
		await this.router.navigate([AppRoutingKeys.urlPathImport, { appendData: JSON.stringify(true) }]);
	}

	public async appendFile(event: any) {
		// console.log("APPEND FILE HERE")
		try {
			this.workfileId = this.queryParamsProvider.workfileId;
			this.importStatus = ImportStatusEnum.importInProgress;
			const file = await this.filePicker.readFile(event);

			// todo: set a global identifier for the supported extensions
			if (readFileExtension(file.fileName).toLowerCase() !== 'json') {
				await this.toastService.presentError(
					this.translateService.instant('alert.import.validationMessages.jsonExtension'),
					ToastDuration.Slow
				);

				throw new Error('Wrong file extension');
			}

			const fileModel = JSON.parse(file.fileContent) as FileModel;
			
			fileModel.FileDisplayName = removeFileExtension(file.fileName, 'json');
			this.fileName = removeFileExtension(file.fileName, 'json');

			this.loadingIndicatorState.setIsLoading(true, "Appending data into current workfile")
			
			await this.workspaceRepository.appendDataToWorkfile(this.workfileId, fileModel.TABLE_DATA);
			this.importStatus = ImportStatusEnum.importDone;
			
			await this.toastService.presentSuccess(
				this.translateService.instant('importPage.messages.importSuccessful'),
				ToastDuration.Fast
			);

		} catch (error) {
			this.importStatus = ImportStatusEnum.importError;
			this.loggingService.error(ErrorCodes.ImportPageError, error);
		} finally {
			this.loadingIndicatorState.setIsLoading(false)
		}
	}

	public toggleArchivedVisibility(e: any): void {
		this.burgerMenuState.setArchived(e.detail.value === ArchivedVisibilityTypeEnum.ShowArchived ? true : false);
	}

	public async deleteWorkFile(workfileId: string): Promise<void> {
		// if you need to redirect to another workfiles
		console.log("workfiles", this.workfiles)
		const workfileArchived = this.workfiles.find(
			(workfile: WorkFileAppModel) => workfile.workFileId === workfileId
		)[CentralDatabaseKeys.archived];

		if (!workfileArchived) {
			return await this.toastService.presentError(
				this.translateService.instant('burgerMenu.deleteValidations.notArchived'),
				ToastDuration.Fast
			);
		}

		const cancelButton = {
			text: this.translateService.instant('burgerMenu.alert.buttons.keepWorkfile'),
			handler: () => {}
		};

		const confirmButton = {
			text: this.translateService.instant('burgerMenu.alert.buttons.deleteWorkfile'),
			handler: async () => {
				await this.deleteWorkfileService.delete(workfileId);

				await this.toastService.presentSuccess(
					this.translateService.instant('burgerMenu.messages.success'),
					ToastDuration.Fast
				);
				await this.navCtrl.navigateForward(AppRoutingKeys.urlPathImport);

			}
		};

		return this.alertService.presentAlert(
			this.translateService.instant('burgerMenu.alert.message'),
			[cancelButton, confirmButton],
			false
		);
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach((subscription) => {
			subscription.unsubscribe();
		});
	}

	private toggleBurgerMenuVisibility(): void {
		this.subscriptions.push(
			this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((route: NavigationEnd) => {
				const urlPath: string[] = route.urlAfterRedirects.split('/').filter((n: string) => n);

				// Burger menu enabled only on these two urls
				// /workfile/WORKFILE_ID/ or /workfile/WORKFILE_ID/project/PROJECT_NAME/
				if (
					(urlPath.length === 2 && urlPath.includes(AppRoutingKeys.urlPathWorkfile)) ||
					(urlPath.length === 4 &&
						urlPath.includes(AppRoutingKeys.urlPathWorkfile) &&
						urlPath.includes(AppRoutingKeys.urlPathProject))
				) {
					setTimeout(() => {
						this.menuIsEnabled = true;
					}, 500);
				} else {
					// delay disabling the menu to avoid freezing the app when navigating from burger menu to import page
					setTimeout(() => (this.menuIsEnabled = false), 500);
				}
			})
		);
	}

	private isAnyRequestInProgress(workfileId: string): boolean {
		if (this.workfileId === workfileId) {
			return false;
		}

		if (this.requestsStatusState.hasAny()) {
			const confirmButton = {
				text: this.translateService.instant('burgerMenu.alert.buttons.changeWorkfile'),
				handler: () => {}
			};

			this.alertService.presentAlert(
				this.translateService.instant('burgerMenu.alert.changeWorkfile'),
				[confirmButton],
				false
			);

			return true;
		}
	}
}
